import { MessageSquare } from "lucide-react";
import React from "react";

type CustomToolbarProps = {
  id: string;
};

const CustomToolbar: React.FC<CustomToolbarProps> = ({ id }) => {
  return (
    <div id={`toolbar-${id}`} className="ql-toolbar ql-snow">
      <span className="ql-formats">
        <select className="ql-header" defaultValue="">
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option value="3">Heading 3</option>
          <option value="">Normal</option>
        </select>
      </span>
      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-strike" />
      </span>
      <span className="ql-formats">
        <button className="ql-list" value="ordered" />
        <button className="ql-list" value="bullet" />
      </span>
      <span className="ql-formats">
        <button className="ql-link" />
        <button className="ql-code-block" />
      </span>
      <span className="ql-formats text-[#444]">
        <button className="ql-clean" />
        <button id={`insert-comment-${id}`}>
          <MessageSquare size={18} />
        </button>
      </span>
    </div>
  );
};

export default CustomToolbar;
